// let inscript = `
// autobonus "{ bonus bBaseAtk,50; }",10,10000,BF_WEAPON,"{ specialeffect2 EF_POTION_BERSERK; }";
// .@r = getrefine();
// bonus bBaseAtk,(.@r/2)*15;
// if (.@r>6) { bonus bAspdRate,10; }
// if (.@r>8) { bonus bAspd,1; bonus bAtkRate,5; }
// if (.@r>10) { bonus bCritAtkRate,15; }
// .@val = max(min(.@r-15,5),0);
// bonus bFixedCast,-.@val*100;
// `

// inscript = transpileVariables(inscript)
// inscript = transpileFunctions(inscript)

// console.log(inscript)

export function transpileVariables(input) {
	let matches = [...input.matchAll(/(\.@)(.+?)=/g)]

	for (let match of matches) {
		let jsVarName = match[2].trim()
		input = input.replace(match[0], `let ${jsVarName} =`)
		input = input.replaceAll(`.@${jsVarName}`, jsVarName)
	}

	return input
}

export function transpileFunctions(input) {
	let fnNames = ['autobonus', 'bonus']
	let markCount = 0
	let marks = {}

	fnNames.forEach((fnName) => {
		let fnRegex = new RegExp(`(^|\\s|\\W)(${fnName})`, 'gi')
		console.log('fnRegex.exec(input)')
		console.log(fnRegex.exec(input))
		let match
		while ((match = fnRegex.exec(input))) {
			let regex
			let endIndex = match.index + match[0].length
			let args = []

			let startIndex = endIndex
			for (; startIndex < input.length; startIndex++) {
				let symbol = input[startIndex]

				if (symbol.match(/["']/)) {
					regex = new RegExp(`(${symbol})(.+?)(${symbol})`, 'y')
					regex.lastIndex = startIndex
					let arg = regex.exec(input)
					startIndex += arg[0].length - 1
					args.push({
						type: 'str',
						val: arg[2],
					})
				} else if (symbol.match(/[\d+]/)) {
					regex = new RegExp(`\\d+`, 'y')
					regex.lastIndex = startIndex
					let arg = regex.exec(input)
					startIndex += arg[0].length - 1
					args.push({
						type: 'int',
						val: arg[0],
					})
				} else if (symbol.match(/[\s,]/)) {
				} else if (symbol.match(/[;]/)) {
					startIndex++
					break
				} else if (symbol.match(/[\w\W]/)) {
					regex = new RegExp(`([\\w\\W]+?)(?:,|;)`, 'y')
					regex.lastIndex = startIndex
					let arg = regex.exec(input)
					startIndex += arg[1].length - 1
					if (arg[1].match(/\W+/)) {
						args.push({
							type: 'exp',
							val: arg[1],
						})
					} else {
						args.push({
							type: 'enum',
							val: arg[1],
						})
					}
				}
			}

			let jsFnCall = `${fnName}${args.length}(`
			args.forEach((value, index) => {
				if (index) {
					jsFnCall += ', '
				}
				if (value.type === 'str' || value.type === 'enum') {
					value.val = value.val.replace('"', '"')
					jsFnCall += `"${value.val}"`
				}
				if (value.type === 'int') {
					jsFnCall += `${parseInt(value.val)}`
				}
				if (value.type === 'exp') {
					jsFnCall += `${value.val}`
				}
			})
			jsFnCall += ');'

			markCount++
			let markName = `#MARK${markCount}`
			marks[markName] = jsFnCall
			input = replacePart(
				input,
				match.index + match[1].length,
				startIndex,
				markName,
			)
		}
	})

	Object.keys(marks).forEach((markName) => {
		input = input.replace(markName, marks[markName])
	})

	return input
}

function replacePart(str, from, to, replace) {
	let result = str.slice(0, from)
	result += replace
	result += str.slice(to)

	return result
}

//Kord's regex
export function bonusRegex(str, val) {
	// console.log(val)
	//regex to select bonus commands
	let regexbonus = new RegExp(str + '\\ (.*?);')
	//split bonus command into an array
	let temp = regexbonus.exec(val)[1].split(',')
	//add quotes to the first command
	temp[0] = '"' + temp[0] + '"'
	for (let i = 0; i < temp.length - 1; i++) {
		if (
			temp[i][0] !== '"' &&
			temp[i][0] !== '-' &&
			isNaN(Number(temp[i][0]))
		)
			temp[i] = '"' + temp[i] + '"'
	}
	//join the array into one string
	temp = temp.join(',')
	//return an usable function call as string
	// console.log(str + '(' + temp + ')')
	return str + '(' + temp + ')'
}
export function autobonusRegex(str, val) {
	let regexbonus = new RegExp(str + '\\ "(.*?".*?)*;')
	// let regexbonus = new RegExp(str + ' (.*?);')
	// 'autobonus("' + regex2.exec(script[i])[1] + '")'
	return str + '("' + regexbonus.exec(val)[1] + ')'
}
export function skillRegex(str, val) {
	//regex to select bonus commands
	let regexbonus = new RegExp(str + '\\ (.*?);')
	//split bonus command into an array
	let temp = regexbonus.exec(val)[1].split(',')
	//add quotes to the first command
	// temp[0] = '"' + temp[0] + '"'
	//join the array into one string
	temp = temp.join(',')
	//return an usable function call as string
	return str + '(' + temp + ')'
}
